import { createIcon } from "@chakra-ui/icons";

export const PlusIcon = createIcon({
  displayName: "PlusIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      d="M12 5V19M5 12H19"
      fill="none"
      stroke="currentColor"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
});
